import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import "@/assets/styles/apps.scss";
import "tailwindcss/base.css";
import "tailwindcss/components.css";
import "tailwindcss/utilities.css";
import { useStore } from "vuex";
import { onMounted } from "vue";
import { Locale, useLocalization } from "@/plugins/i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { state, commit } = useStore();
const { setLocale } = useLocalization();

onMounted(() => {
  commit("setTheme", localStorage.getItem("theme") || "dark");
  setLocale((localStorage.getItem("language") || "en") as Locale);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_unref(state).theme}-theme`)
  }, [
    _createVNode(_component_router_view)
  ], 2))
}
}

})